module.exports = __webpack_public_path__ + "img/gb.8c7283aa.png";